import { useQuery } from '@common-fe/common-fe';

import { api } from '@/api';
import { API_URL } from '@/dtos';

const QUERY_KEY = 'getEmailTemplateVariablesQueryKey';

export const useGetEmailTemplateVariablesQuery = (emailTemplateId?: string, orgId?: string) => {
  const { data, isLoading } = useQuery(
    [QUERY_KEY, emailTemplateId],
    emailTemplateId
      ? () =>
          api.get(API_URL.EXTERNAL_TEMPLATES_VARIABLES_BY_ID(emailTemplateId), {
            params: {
              ...(orgId && { organization_id: orgId }),
            },
          })
      : () => null,
    {
      cacheTime: 0,
      retry: 0,
    }
  );

  return {
    data: data?.data,
    isLoading,
  };
};
